import { motion } from "framer-motion";
import { Instagram, Phone, MapPin, Mail } from "lucide-react";
import { SITE } from "@/data/site";

const EASE = [0.76, 0, 0.24, 1];

export const Contato = () => (
    <section
        id="contato"
        data-testid="contato-section"
        className="relative bg-[var(--ink)] text-white py-24 md:py-32 border-t border-white/10"
    >
        <div className="container-x">
            <div className="grid grid-cols-12 gap-6">
                <div className="col-span-12 md:col-span-5">
                    <div className="flex items-center gap-3 text-[11px] tracking-[0.32em] uppercase text-white/50 font-body">
                        <span className="inline-block h-px w-10 bg-white/40" />
                        <span>Seção 05</span>
                    </div>
                    <motion.h2
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.9, ease: EASE }}
                        data-testid="contato-title"
                        className="font-display text-[13vw] md:text-[6.5vw] lg:text-[5.5vw] mt-6"
                    >
                        Contato <br />
                        <span className="font-editorial italic font-medium text-[var(--sun)]">
                            & bastidores.
                        </span>
                    </motion.h2>
                    <p className="mt-8 font-body text-[15px] leading-relaxed text-white/70 max-w-md">
                        Estamos abertos a conversar sobre parcerias, projetos
                        institucionais, apoios pontuais ou visitas ao campo.
                        Chame no WhatsApp ou pelo Instagram.
                    </p>
                </div>

                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.9, ease: EASE, delay: 0.1 }}
                    className="col-span-12 md:col-span-6 md:col-start-7 grid grid-cols-1 sm:grid-cols-2 gap-4"
                >
                    {SITE.phones.map((p, idx) => (
                        <a
                            key={p}
                            href={`tel:${p.replace(/\D/g, "")}`}
                            data-testid={`contato-phone-${idx + 1}`}
                            className="group border border-white/15 p-6 hover:border-[var(--sun)] transition-colors duration-300"
                        >
                            <Phone
                                size={18}
                                className="text-[var(--sun)] mb-6"
                            />
                            <div className="text-[10px] tracking-[0.32em] uppercase text-white/50 font-body">
                                Telefone {String(idx + 1).padStart(2, "0")}
                            </div>
                            <div className="mt-2 font-display text-xl md:text-2xl link-sweep w-fit">
                                {p}
                            </div>
                        </a>
                    ))}
                    <a
                        href={SITE.instagram}
                        target="_blank"
                        rel="noreferrer"
                        data-testid="contato-instagram"
                        className="group border border-white/15 p-6 hover:border-[var(--sun)] transition-colors duration-300"
                    >
                        <Instagram
                            size={18}
                            className="text-[var(--sun)] mb-6"
                        />
                        <div className="text-[10px] tracking-[0.32em] uppercase text-white/50 font-body">
                            Instagram
                        </div>
                        <div className="mt-2 font-editorial italic text-xl md:text-2xl link-sweep w-fit break-all">
                            @novo_horizonte.futebol.club
                        </div>
                    </a>
                    <a
                        href={`mailto:${SITE.email}`}
                        data-testid="contato-email"
                        className="group border border-white/15 p-6 hover:border-[var(--sun)] transition-colors duration-300"
                    >
                        <Mail
                            size={18}
                            className="text-[var(--sun)] mb-6"
                        />
                        <div className="text-[10px] tracking-[0.32em] uppercase text-white/50 font-body">
                            E-mail
                        </div>
                        <div className="mt-2 font-editorial italic text-2xl md:text-3xl link-sweep w-fit break-all">
                            {SITE.email}
                        </div>
                    </a>
                    <div
                        className="sm:col-span-2 border border-white/15 p-6 flex items-start gap-6"
                        data-testid="contato-endereco"
                    >
                        <MapPin size={18} className="text-[var(--sun)] mt-1" />
                        <div>
                            <div className="text-[10px] tracking-[0.32em] uppercase text-white/50 font-body">
                                Sede
                            </div>
                            <div className="mt-2 font-editorial italic text-2xl">
                                {SITE.location}
                            </div>
                            <div className="mt-2 font-body text-[13px] text-white/60">
                                CNPJ: {SITE.cnpj}
                            </div>
                        </div>
                    </div>
                </motion.div>
            </div>
        </div>
    </section>
);
